<div class="main-container">
  <div class="header">
    <div class="title programs-h5">Program Simulations</div>

    <div class="right-elements">
      <p *ngIf="xpLeft !== undefined"> {{ xpLeft }}/{{ xpAllowed }} left</p>
      <button mat-raised-button color="primary" (click)="addCourse(learnspace)" plan-limit [canDo]="canCreateXp()" [customTooltip]="'Upgrade to create new ' + (learnspace?.mode | courseLabel:true)" >
        <mat-icon fontSet="fa" fontIcon="fa-plus-circle"></mat-icon>
        NEW {{ learnspace?.mode | courseLabel | uppercase }}
      </button>
    </div>
  </div>
  
  <div class="simulations-container">
    <!-- Empty list: create new simulation -->
    <div class="empty-program-container" *ngIf="learnspace && learnspace.courses.length === 0 && canCreateXp()" (click)="addCourse(learnspace)">
      CREATE A NEW {{ learnspace?.mode | courseLabel | uppercase }}
      <mat-icon fontSet="fa" color="primary" fontIcon="fa-plus-circle"></mat-icon>
    </div>

    <!-- List of simulations -->
    <simulation-list *ngIf="learnspace"
      [learnspaceCourse]="learnspace"
      [canCreateCourse]="canCreateXp()"
      (onListChanged)="updatePermission($event)"
    ></simulation-list>
  </div>
</div>
